import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { EditComponentProps } from 'material-table';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { fetchAppConfigByProfileName } from '../Appconfig';
import { Period } from '../../../utils/types';

const Dropdown: React.FC<Props> = ({
	autoSelect,
	freeSolo,
	disableClearable,
	selectOnFocus,
	required,
	sport,
	leagueId,
	type,
	teamId,
	teams,
	editComponentProps,
	classes,
	onChange,
	getDropdownFunction
}) => {
	useEffect(() => {
		const getDropdownOptionsConfig = async (): Promise<void> => {
			const appConfigContent = await fetchAppConfigByProfileName('mgmt_ui_appconfig_dropdown_profile');
			if (appConfigContent) setDropDownOptions(JSON.parse(appConfigContent));
		};
		getDropdownOptionsConfig();
	}, []);
	const [dropDownOptions, setDropDownOptions] = useState<Record<string, unknown>>({});
	return (
		<Autocomplete
			autoSelect={autoSelect}
			freeSolo={freeSolo}
			disableClearable={disableClearable}
			selectOnFocus={selectOnFocus}
			onChange={onChange}
			options={getDropdownFunction(dropDownOptions, sport ?? '', type ?? 'Action', leagueId, teamId, teams)}
			value={editComponentProps.value}
			renderInput={(params): JSX.Element => <TextField {...params} className={classes.dropdowns} required={required} />}
		/>
	);
};

export default Dropdown;

type Props = {
	autoSelect?: boolean;
	required?: boolean;
	freeSolo?: boolean;
	disableClearable?: boolean;
	selectOnFocus?: boolean;
	onChange?: (event: unknown, newValue: string | null) => void;
	getDropdownFunction: (...args: unknown[]) => string[];
	sport: string | null | undefined;
	editComponentProps: EditComponentProps<EditablePeriod>;
	classes: ClassNameMap;
	teamId?: string;
	leagueId?: string;
	type?: string;
	teams?: string[];
};

type EditablePeriod = {
	data: Period;
	firstSegment: string;
	secondSegment: string;
	thirdSegment: string;
	fourthSegment: string;
	editorial?: boolean;
	warn?: boolean;
};
